<template>
  <div id="gallery" class="gallery-wrap pb-100">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <div class="section-title style3 text-center mb-40">
            <h2>
              Manejamos las mejores marcas de lentes
            </h2>
          </div>
        </div>
      </div>

      <div class="gallery-item-wrap style1">
        <div
          class="gallery-card style3"
          v-for="gallery in galleries"
          :key="gallery.id"
        >
          <img :src="gallery.image" alt="Image" />
          <!--
          <div class="gallery-info">
            <div class="gallery-info-left">
              <h5>
                <router-link to="/gallery-details">
                  {{ gallery.title }}
                </router-link>
              </h5>
              <span>{{ gallery.tag }}</span>
            </div>
            <div class="gallery-info-right">
              <router-link class="gallery-icon" to="/gallery-details">
                <i class="ri-add-line"></i>
              </router-link>
            </div>
          </div>
        -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "GalleryExhibition",
  data: () => ({
    galleries: [
  {
    id: 1,
    image: require("../../assets/images/marcas/1.jpg"),
    title: "Optometrist",
    tag: "Special Service",
  },
  {
    id: 2,
    image: require("../../assets/images/marcas/2.jpg"),
    title: "Optometrist",
    tag: "Special Service",
  },
  {
    id: 3,
    image: require("../../assets/images/marcas/3.jpg"),
    title: "Optometrist",
    tag: "Special Service",
  },
  {
    id: 4,
    image: require("../../assets/images/marcas/4.jpg"),
    title: "Optometrist",
    tag: "Special Service",
  },
  {
    id: 5,
    image: require("../../assets/images/marcas/5.png"),
    title: "Optometrist",
    tag: "Special Service",
  },
  {
    id: 6,
    image: require("../../assets/images/marcas/6.png"),
    title: "Optometrist",
    tag: "Special Service",
  },
  {
    id: 7,
    image: require("../../assets/images/marcas/7.png"),
    title: "Optometrist",
    tag: "Special Service",
  },
  {
    id: 8,
    image: require("../../assets/images/marcas/8.png"),
    title: "Optometrist",
    tag: "Special Service",
  },
  {
    id: 9,
    image: require("../../assets/images/marcas/9.png"),
    title: "Optometrist",
    tag: "Special Service",
  },
  {
    id: 10,
    image: require("../../assets/images/marcas/10.jpg"),
    title: "Optometrist",
    tag: "Special Service",
  },
  {
    id: 11,
    image: require("../../assets/images/marcas/11.png"),
    title: "Optometrist",
    tag: "Special Service",
  },
  {
    id: 12,
    image: require("../../assets/images/marcas/12.png"),
    title: "Optometrist",
    tag: "Special Service",
  },
  {
    id: 13,
    image: require("../../assets/images/marcas/13.png"),
    title: "Optometrist",
    tag: "Special Service",
  },
  {
    id: 14,
    image: require("../../assets/images/marcas/14.jpg"),
    title: "Optometrist",
    tag: "Special Service",
  },
],

  }),
});
</script>